module.exports = __webpack_public_path__ + "img/gys-icon-4.a6831140.png";